<template>
  <el-row class="pa-2 fs-vh-100">
    <el-col :span="24" class="text-center">
      <div class="close-icon-head" @click="redirectToMenu">
        <i class="el-icon-back"></i>
      </div>
      <el-image 
        v-if="branchDetail && branchDetail.logo"
        class="big-logo"
        :src="'https://images.foodstory.co/' + branchDetail.logo"
        fit="cover"
      />
    </el-col>
    <el-col :span="24" class="text-center auth-text">
      <h3 class="mb--0 text-title--large">{{ $t('otpauth.header') }}</h3>
      <p class="color-smokegray--text mt--3 mb--6 text-heading3">{{ $t('otpauth.description') }}</p>
    </el-col>
    <el-col class="text-center">
      <div class="flex fs-entry-otp mb--5">
        <div 
          :class="{ 'color-danger--border': OTPValidateForm.error }"
          class="otp-input-box" 
          v-for="dot in [0,1,2,3,4,5]" 
          :key="'dot-'+dot"
        >
          <div class="dot" v-if="OTPValidateForm.numberOTP.length >= dot+1"></div>
          <div class="fs-cursor" v-if="OTPValidateForm.numberOTP.length == dot">|</div>
        </div>
        <input 
          type="text" 
          inputmode="numeric" 
          pattern="[0-9]*" 
          @input="authOTPCode()" 
          autocomplete="off" 
          maxlength="6" 
          ref="otp_input" 
          id="hide-input" 
          v-model="OTPValidateForm.numberOTP"
        >
      </div>
      <span v-show="OTPValidateForm.error" class="d-flex justify-center">
        <img :src="require('@/assets/icons/svg/warning-circle.svg')" width="16" height="16" />
        <span class="text-body ml--1 color-danger--text">{{ OTPValidateForm.error }}</span>
      </span>
    </el-col>
    <br>
    <el-col class="p-36">
      <!-- <el-form :model="OTPValidateForm" ref="OTPValidateForm" class="demo-ruleForm">
        <el-form-item
          label=""
          prop="numberOTP"
          :rules="[
            { required: true, message: 'OTP is required'},
          ]"
        >
          <el-input type="numberOTP" maxlength="6"  class="text-otp" v-model="OTPValidateForm.numberOTP" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          หากไม่ได้รับ OTP กรุณากด Resend OTP
          <el-button type="primary" @click="resendCodeOTP">resendCodeOTP</el-button><br>
          <el-button type="primary" @click="authOTPCode('OTPValidateForm')">authOTPCode</el-button>
        </el-form-item>
      </el-form> -->
          <div class="text-center resent">
            <span 
              v-if="countDownTime"
              class="text-subtitle--med color-smokegray--text" 
            >
             {{ $t('otpauth.countDown') }}&ensp;{{ formattedCountDownTime }}
           </span>
           <a 
             v-else 
             type="primary" 
             class="text-subtitle--med" 
             style="text-decoration: underline;"
             @click="resendCodeOTP"
           >
             {{ $t('otpauth.reciveCodeAgain') }}
           </a>
          </div>
          <!-- <a type="primary" @click="authOTPCode('OTPValidateForm')">authOTPCode</a> -->
      <!-- Recap Char Auth Firebase Phone Number -->
      <div id="sign-in-button"></div>
    </el-col>
  </el-row>
</template>
<script>

// The key is used for storing and getting the otp countdown time from sessionStorage to continue counting down
const OTP_COUNTDOWN_TIMER_KEY = 'otpcdt'

export default {
  name: 'AuthPhoneNumberOTP',
  props: ['restaurant_uuid', 'branch_uuid'],
  data: function() {
    return {
      numberOTP: null,
      OTPValidateForm: { numberOTP: '', error: '' },
      loading: false,

      countDownTime: 0,
      countDowninterval: null
    }
  },
  destroyed: function() {
    this.$store.dispatch('endLoading')
  },
	methods: {
    authOTPCode: function () {
      this.submitOTP();
    },
    submitOTP: async function() {
      try {
        if (this.OTPValidateForm.numberOTP.length == 6) {
          await this.$store.dispatch('verifyCodeOTP', {
            restaurantAlias: this.restaurant_uuid,
            branchAlias: this.branch_uuid,
            numberOTP: this.OTPValidateForm.numberOTP.toString(),
            verificationId: this.$route.query.verificationId.toString()
          })
          this.OTPValidateForm.error = ''
          await this.$store.dispatch('startLoading')
        }
      } catch (error) {
        this.OTPValidateForm.numberOTP = ''
        this.OTPValidateForm.error = error.message
        throw error
      }
    },
    resendCodeOTP: function() {
      this.$store.dispatch('verifyPhoneNumber', {
        restaurant_uuid: this.branchDetail.restaurantId,
        branch_uuid: this.branchDetail.id,
        restaurantAlias: this.restaurant_uuid,
        branchAlias: this.branch_uuid,
        phoneNumber:  this.$route.query.phoneNumber
      })
      this.startOtpCountDown()
    },
    redirectToMenu: function() {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}` })
    },
    startOtpCountDown: function(second = 120) {
      this.countDownTime = second;
      this.countDowninterval = setInterval(() => {
        const counted = this.countDownTime - 1;
        this.countDownTime = counted >= 0 ? counted : 0;
        sessionStorage.setItem(OTP_COUNTDOWN_TIMER_KEY, this.countDownTime)

        if (!this.countDownTime) {
          clearInterval(this.countDowninterval)
        }
      }, 1000)
    },
    initOtpCountDown: function() {
      const timeFromStore = sessionStorage.getItem(OTP_COUNTDOWN_TIMER_KEY)
      const timeParsed = Number.parseInt(timeFromStore)
      if (Number.isInteger(timeParsed)) return this.startOtpCountDown(timeParsed)
      return this.startOtpCountDown()
    }
  },
  computed:{
    formattedCountDownTime: function() {
      const minute = Math.floor(this.countDownTime / 60).toString().padStart(2, '0')
      const second = Math.floor(this.countDownTime % 60).toString().padStart(2, '0')
      return minute + ':' + second
    },
    branchDetail: function() {
      return this.$store.getters.BranchDetail
    }
  },
  mounted: function() {
    this.initOtpCountDown()
    this.$nextTick(()=>{
      this.$refs.otp_input.focus();
    });
  },
  beforeDestroy: function() {
    clearInterval(this.countDowninterval)
    sessionStorage.removeItem(OTP_COUNTDOWN_TIMER_KEY)
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/verify/AuthPhoneNumberOTP.vue